import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { faChartLine } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-data-analysis',
  templateUrl: './data-analysis.component.html',
  styleUrl: './data-analysis.component.css'
})
export class DataAnalysisComponent {

  faChartLine = faChartLine;
  state: string = 'sale';
  branchMode: boolean;

  constructor(router: Router) {
    this.branchMode = router.url.startsWith('/branch/');
  }
}
